import { requestBuilder } from '../../http/RequestBuilder';
import type InterestRate from '../types/InterestRate';

const useGetCurrentInterestRateAndApy = requestBuilder.query<InterestRate>({
    endpoint: '/api/bank-accounts/current-apy',
    queryKey: 'getCurrentInterestRateAndApy/current-apy',
});

export default useGetCurrentInterestRateAndApy;
